export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8978.71d7fe75.jpg";